import api from "./api";
import {
  PaginatedResponse,
  RelatorioPagamentoFranquia,
  RelatorioPagamentoAssinante,
} from "../types/relatorios";
import { FiltrosRelatorio } from "../components/financeiro/RelatorioFiltros";

/* helper */
const filtrosToParams = (filtros?: FiltrosRelatorio) => {
  let ano: number | undefined;
  let mes: number | undefined;

  if (filtros?.mesPagamento) {
    const [year, month] = filtros.mesPagamento.split("-");
    ano = Number(year);
    mes = Number(month); // já vem 1–12
  }

  return {
    // 🔍 search unificado
    search: filtros?.franqueado || filtros?.assinante,

    plano: filtros?.plano,

    ano,
    mes,

    status:
      filtros?.status === "Pago"
        ? "PAGO"
        : filtros?.status === "Pendente"
        ? "PENDENTE"
        : undefined,
  };
};


/* =========================
   ADMIN – FRANQUIAS
========================= */
const getRelatorioPagamentosFranquia = async (
  page = 1,
  filtros?: FiltrosRelatorio
) => {
  const response = await api.get<
    PaginatedResponse<RelatorioPagamentoFranquia>
  >("/api/relatorio-pagamentos-franquia/", {
    params: {
      ...filtrosToParams(filtros),
    },
  });

  return response.data;
};

/* =========================
   ADMIN – ASSINANTES (GERAL)
========================= */
const getRelatorioPagamentosAssinante = async (
  page = 1,
  filtros?: FiltrosRelatorio
) => {
  const response = await api.get<
    PaginatedResponse<RelatorioPagamentoAssinante>
  >("/api/relatorio-pagamentos-assinante/", {
    params: {
      ...filtrosToParams(filtros),
    },
  });

  return response.data;
};

/* =========================
   FRANQUIA – ASSINANTES DA FRANQUIA
========================= */
const getRelatorioAssinantesPorFranquia = async (
  franquiaId: number,
  page = 1,
  filtros?: FiltrosRelatorio
) => {
  const response = await api.get<
    PaginatedResponse<RelatorioPagamentoAssinante>
  >(
    `/api/relatorio-pagamentos-assinante/por-franquia/${franquiaId}/`,
    {
      params: {
        ...filtrosToParams(filtros),
      },
    }
  );

  return response.data;
};


/* =========================
   PATCH – ATUALIZAR PAGAMENTO ASSINANTE
========================= */
const patchPagamentoAssinante = async (
  id: number,
  payload: {
    status: "Pago" | "Pendente";
    forma_pagamento: string;
  }
) => {
  const response = await api.patch(
    `/api/relatorio-pagamentos-assinante/${id}/`,
    {
      status: payload.status === "Pago" ? "PAGO" : "PENDENTE",
      forma_pagamento: payload.forma_pagamento,
    }
  );

  return response.data;
};

/* =========================
   PATCH – ATUALIZAR PAGAMENTO FRANQUIA
========================= */
const patchPagamentoFranquia = async (
  id: number,
  payload: {
    status: "Pago" | "Pendente";
    forma_pagamento: string;
  }
) => {
  await api.patch(
    `/api/relatorio-pagamentos-franquia/${id}/`,
    {
      status: payload.status === "Pago" ? "PAGO" : "PENDENTE",
      forma_pagamento: payload.forma_pagamento,
    }
  );
};

export const relatoriosService = {
  getRelatorioPagamentosFranquia,
  getRelatorioPagamentosAssinante,
  getRelatorioAssinantesPorFranquia,
  patchPagamentoAssinante,
  patchPagamentoFranquia,
};
